import { useState } from "react";
import { Input } from "@/components/ui/input";
import { displayCurrency } from "@/lib/format";

// Champ effacé puis quitté (clic ailleurs ou Entrée) sans nouvelle saisie : la valeur d'origine revient.
const keepOnEmpty = (shown, setDraft, onChange, props) => ({
  onFocus: (e) => { setDraft(shown); props.onFocus?.(e); },
  onChange: (e) => { const v = e.target.value; setDraft(v); if (v !== "") onChange(v); },
  onBlur: (e) => { setDraft(null); props.onBlur?.(e); },
  onKeyDown: (e) => { if (e.key === "Enter") e.currentTarget.blur(); props.onKeyDown?.(e); },
});

// Champ montant (valeur en €) affiché et saisi dans la devise d'affichage ; on peut effacer une partie des chiffres et les retaper.
export const AmountInput = ({ value, onChange, ...props }) => {
  const [draft, setDraft] = useState(null);
  const rate = displayCurrency().rate || 1;
  const shown = draft ?? (value === "" || value == null ? "" : String(rate === 1 ? Math.round(Number(value) * 100) / 100 : Math.round(Number(value) * rate)));
  return <Input type="number" min={0} {...props} value={shown} {...keepOnEmpty(shown, setDraft, (v) => onChange(String(Number(v) / rate)), props)} />;
};

// Champ pourcentage avec le même comportement
export const PctInput = ({ value, onChange, ...props }) => {
  const [draft, setDraft] = useState(null);
  const shown = draft ?? (value === "" || value == null ? "" : String(value));
  return <Input type="number" min={0} max={100} {...props} value={shown} {...keepOnEmpty(shown, setDraft, onChange, props)} />;
};
